import React__default from 'react';
import getRendererWithHeadingForResultType from './RendererWithLocalizedHeadingFactory.js';
import FlyoutResult from './FlyoutResult.js';
import ResultText from './ResultText.js';
import { SquareImageContainer, tokens, FluidImage, Typography } from '@vp/swan';

var Result = function Result(_ref) {
  var _result$_highlightRes, _result$_highlightRes2;
  var result = _ref.result;
  var label = "".concat(result === null || result === void 0 || (_result$_highlightRes = result._highlightResult) === null || _result$_highlightRes === void 0 || (_result$_highlightRes = _result$_highlightRes.title) === null || _result$_highlightRes === void 0 ? void 0 : _result$_highlightRes.value, " - ").concat(result === null || result === void 0 || (_result$_highlightRes2 = result._highlightResult) === null || _result$_highlightRes2 === void 0 || (_result$_highlightRes2 = _result$_highlightRes2.description) === null || _result$_highlightRes2 === void 0 ? void 0 : _result$_highlightRes2.value);
  var ariaTitle = "".concat(result === null || result === void 0 ? void 0 : result.title, "\n                    ").concat((result === null || result === void 0 ? void 0 : result.description) || '');
  return /*#__PURE__*/React__default.createElement(FlyoutResult, {
    resultId: result.objectID,
    result: result,
    landingUrl: result.landingUrl
  }, /*#__PURE__*/React__default.createElement(SquareImageContainer, {
    bgc: "strong",
    style: {
      width: tokens.SwanSemSpace9,
      flexShrink: 0,
      borderRadius: tokens.SwanSemBorderRadiusStandard
    }
  }, /*#__PURE__*/React__default.createElement(FluidImage, {
    className: "search-flyout-item-image",
    src: result.imageUrl,
    alt: "",
    margin: "auto",
    style: {
      borderRadius: '4px'
    }
  })), /*#__PURE__*/React__default.createElement(Typography, {
    className: "search-flyout-item-name",
    textAlign: "left",
    pl: 3,
    pr: 2,
    ml: 3
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement(ResultText, {
    resultText: label
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "swan-visually-hidden"
  }, ariaTitle), /*#__PURE__*/React__default.createElement("span", null)));
};
var ImageAndDescriptionFlyoutTaxonomyRenderer = getRendererWithHeadingForResultType(Result);

export { ImageAndDescriptionFlyoutTaxonomyRenderer as default };
//# sourceMappingURL=FlyoutRendererWithImageAndDescription.js.map
